/* eslint-disable prettier/prettier */
import React, { useState } from 'react';
import { Input } from 'app/components/ui/input';
import { useFormContext } from 'react-hook-form';
import { endpoints } from 'utils/api/endpoints';
import { Button } from 'app/components/ui/button';

function Title() {
  const { register, setValue } = useFormContext();
  const [slug, setSlug] = useState('');

  // Handle changes to the title and generate the slug
  const handleTitleChange = event => {
    const value = event.target.value;
    const generatedSlug = value
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, '-') // Replace spaces/special characters with hyphens
      .replace(/^-+|-+$/g, ''); // Remove leading/trailing hyphens
    setSlug(generatedSlug);
    setValue('slug', generatedSlug); // Update form context
  };

  // Handle manual edits to the slug
  const handleSlugChange = event => {
    const value = event.target.value;
    setSlug(value);
    setValue('slug', value); // Update form context
  };

  return (
    <div>
      {/* Title input */}
      <Input
        placeholder="Add Title"
        className="border border-black h-[40px] rounded px-2 w-full bg-white  dark:bg-transparent"
        {...register('title', {
          required: 'Title is required',
          onChange: handleTitleChange, // Trigger slug generation
        })}
      />
      {/* Permalink/Slug input */}
      <p className="mt-1 text-sm flex items-center gap-1">
        <span className="text-slate-500">Permalink:</span>
        <span>{endpoints.appBaseUrl}/blogs/</span>

        <div className="flex items-center w-full">
          <Input
            className="border !border-transparent h-[40px] rounded px-0 w-full focus:border-blue-500 focus:border-b focus:text-primary"
            value={slug}
            onChange={e => {
              handleSlugChange(e);
              register('slug').onChange(e); // react-hook-form handler
            }}
          />
        </div>
      </p>
    </div>
  );
}

export default Title;
